import React from 'react';
import cx from 'classnames';
import { getMalpracticeExpiry } from '../../malpracticeExpiry';
import s from './s.module.less';

type Props = {
    expireDate: any;
    className?: string;
};

// 原型 malpracticeWarnHTML：Malpractice 步骤日期行下方 + Settings / Review 只读视图里，
// 30 天内黄底、已过期红底；不在提醒窗口内不渲染
export default function MalpracticeExpiryNotice({ expireDate, className }: Props) {
    const expiry = getMalpracticeExpiry(expireDate);
    if (!expiry) return null;
    return <div className={cx(s.notice, expiry.expired ? s.expired : s.expiring, className)}>{expiry.text}</div>;
}
